import React from 'react';
import AssignmentActionFlowModal, {
	ActionTarget,
	ActionTargetOption,
	ActionSummary
} from '../AssignmentActionFlowModal';

export type UnassignTarget = ActionTarget;

const UNASSIGN_OPTIONS: ActionTargetOption[] = [
	{
		value: 'all',
		title: 'All previously selected users',
		description:
			'Unassign this training to all users included in the last assignment.'
	},
	{
		value: 'specific',
		title: 'Specific users',
		description:
			'Unassign this training from selected users only, based on property, group or individual selection.'
	}
];

const plural = (count: number, noun: string) =>
	`${count} ${noun}${count === 1 ? '' : 's'}`;

const unassignAllItems = ({ userCount }: ActionSummary): string[] => [
	`Unassign ${plural(userCount, 'learner')}`,
	'Delete any progress they have made'
];

const unassignSpecificItems = (summary: ActionSummary): string[] => [
	...(summary.entityCount
		? [`Affect ${plural(summary.entityCount, 'selection')}`]
		: []),
	...unassignAllItems(summary)
];

interface UnassignScheduledModalProps {
	visible: boolean;
	assignmentId: number;
	scopes: string[];
	tenantId?: number;
	onCancel: () => void;
	onContinue: (
		target: UnassignTarget,
		userIds?: string[]
	) => void | Promise<void>;
}

const UnassignScheduledModal: React.FC<UnassignScheduledModalProps> = ({
	visible,
	assignmentId,
	scopes,
	tenantId,
	onCancel,
	onContinue
}) => (
	<AssignmentActionFlowModal
		visible={visible}
		assignmentId={assignmentId}
		scopes={scopes}
		tenantId={tenantId}
		audience
		onCancel={onCancel}
		onContinue={onContinue}
		select={{
			title: 'Unassign training',
			description: 'Choose who you want to unassign this training from.',
			options: UNASSIGN_OPTIONS,
			actionLabel: 'Continue'
		}}
		confirmAll={{
			title: 'Unassign training?',
			intro: 'Unassigning this training will:',
			items: unassignAllItems,
			actionLabel: 'Unassign'
		}}
		specific={{
			title: 'Unassign specific users',
			description: 'Unassign users from this training',
			actionLabel: 'Continue'
		}}
		confirmSpecific={{
			title: 'Confirm unassign',
			intro: 'Unassigning this training will:',
			items: unassignSpecificItems,
			actionLabel: 'Unassign'
		}}
	/>
);

export default UnassignScheduledModal;
